import artwork204370 from "../../../assets/curation/2/204370.jpg";
import artwork212711 from "../../../assets/curation/2/212711.jpg";
import artwork215068 from "../../../assets/curation/2/215068.jpg";
import artwork45016 from "../../../assets/curation/2/45016.jpg";
import artwork174889 from "../../../assets/curation/2/174889.jpg";
import artwork83090 from "../../../assets/curation/2/83090.jpg";
import artwork65393 from "../../../assets/curation/2/65393.jpg";
import artwork12109 from "../../../assets/curation/2/12109.jpg";
import artwork214908 from "../../../assets/curation/2/214908.jpg";

const data = {
  title: "Crash",
  subtitle: "PRISMA #3",
  curated: "Curated by<br/>Mari Nagem in Cryptonudes",
  description: `
  Contemporary machines were developed to crash, they don't live long. Humans also crash, like the financial market. In contemporary times, everything has an economic value, integrating a symbolic cost system. It’s no different for bodies. They are still associated with a historical construction where fresh white flesh makes better business. Can cryptocurrencies change how we relate to body-values?  
  `,
  artists: [
    {
      artist: ["Kink Barbie"],
      title: "Nude",
      profile: ["tz1ecGeApK7ov11QrJuveCruAsMi7tVBWAyY"],
      description: `Nude (1), 2019
      by Kink Barbie
      
      A stack of flash, a continuous body.
      
      
      this work is part of the "Nude" series.`,
      objktID: 204370,
      artwork: artwork204370,
    },
    {
      artist: ["Calkiel"],
      title:
        "travaille dans le jardin / works in the garden / trabalha na horta, 2021",
      profile: ["tz1gNj5PcHory8BqadjWY5hUeRfwwYtQnANE"],
      description: `With the series of photographs [quotidiennement / everyday / cotidianamente, 2021] _calkiel defies the biopolitics impressed on her body. With the help of photographer Franklin Lopes registers the performance. Each image is entitled by the action-place where it is performed.
      4000x6000 300dpi
        `,
      objktID: 212711,
      artwork: artwork212711,
    },
    {
      artist: ["Tao Bruni"],
      title: "How can I help you?",
      profile: ["tz1NoLnrKqjybdmQXfMQ2WnMXebcCjhwScAs"],
      description: `Original: "Gosto de ver você sentindo dor" 
      Translation: "I like to see you in pain"
      
      This image is part of a selection of print screens taken from messages I receive during conversations, with my clients, using the website I access when I need to exchange my digital body image for money.`,
      objktID: 215068,
      artwork: artwork215068,
    },
    {
      artist: ["Bonbi"],
      title: "ḧ̶̻o̸̳̽r̶͍̀n̶̩̊",
      profile: ["tz1M4W1XThSs5bFRBzNsmiXPXM7cyzQBpT2n"],
      description: `twitter @_bonbi // insta @b_onbi`,
      objktID: 45016,
      artwork: artwork45016,
    },
    {
      artist: ["Amanda Devulski"],
      title: "P9130063.jpg 13/09/2003 10:30 #21",
      profile: ["tz1d8ukZmLdptnm5KzY6BP1qaWocwpmFswig"],
      description: `digital archive from Wednesday Saturday 13 September 2003 640×480 jpeg / Ultrasuperfície 2003-2005 ultrasuperficie.net now on view at aarea.co`,
      objktID: 174889,
      artwork: artwork174889,
    },
    {
      artist: ["KariMassey"],
      title: "Ikari",
      profile: ["tz1RuYA8chTMbzxaD8ZC5UNCnbjAbPipyvJE"],
      description: `怒り Ikari -

      hatred, anger, rage
      
      “Punishing the other person is self-punishment. That is true in every circumstance.”
      
      2048 × 1440, 
      
      2021`,
      objktID: 83090,
      artwork: artwork83090,
    },
    {
      artist: ["Violet Forest"],
      title: "Street Surveillance Technologies (2021)",
      profile: ["tz1WfNXHdmkhEFbMet2TaU8Q9VbJ4BMpwXCb"],
      description: `Object detection, pose estimation, & face detection of footage of BLM & HK protests, & archival Black Panther footage serve as an example of what government agency surveillance systems are technically capable of seeing. This artwork serves to remind protestors to cover their face during demonstrations. https://bit.ly/3slyrT2 This artwork was donated by @violet_forest to help raise money for protestors in Colombia. —> https://bit.ly/3h1Uk7J  100% of the proceeds will go to https://bit.ly/3haO9i1`,
      objktID: 65393,
      artwork: artwork65393,
    },
    {
      artist: ["Eduardo Moreira"],
      title: "QUE DEUS PERDOE ESSAS PESSOAS RUINS",
      profile: ["tz1RP2JCzGLH2xCXhue5oirjrFB1Zdu8E5vm"],
      description: `shirt that says "may god forgive these bad people" based on the iconic shirt that Adriano Imperador wore in 2010's brazil state football league. Artist: Eduardo Moreira IG: @eyjdu @moxlab`,
      objktID: 12109,
      artwork: artwork12109,
    },
    {
      artist: ["Mari Nagem in Cryptonudes"],
      title: "Cryptonudes_FLESH_s2_02",
      profile: ["tz1gg93yFLGUXM6vUajgr4URvQNyCkKv6x3D"],
      description: `Carnality. Fresh flesh. How much does a body worth?`,
      objktID: 214908,
      artwork: artwork214908,
    },
  ],
};

export default data;
